document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.single_bar_button').forEach(button => {
        button.addEventListener('click', () => {
            document.querySelector('.single_menu')?.classList.toggle('single_menu-open');
        });
    })
});